// WIKI - https://day.js.org/docs/en/display/format

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const DATE_STRATEGY = {
  DATE_AND_TIME: "DATE_AND_TIME",
  DATE_ONLY: "DATE_ONLY",
  TIME_ONLY: "TIME_ONLY",
  DATE_ISO: "DATE_ISO",
  DATE_TIME_ISO: "DATE_TIME_ISO",
  DATE_TIME_ISO_AMPM: "DATE_TIME_ISO_AMPM",
  DATE_US: "DATE_US",
};

// Parse date strings that may be in various formats
const parseDate = (value) => {
  // If it's already a valid dayjs object or standard format, use it directly
  const directParse = dayjs(value);
  if (directParse.isValid() && typeof value !== 'string') {
    return directParse;
  }
  
  // Try common formats for string values
  const formats = [
    "MM/DD/YYYY hh:mmA",      // 02/06/2026 06:15PM
    "MM/DD/YYYY hh:mm A",     // 02/06/2026 06:15 PM
    "MM/DD/YYYY HH:mm",       // 02/06/2026 18:15
    "YYYY-MM-DD HH:mm:ss",    // 2026-02-06 18:15:00
    "YYYY-MM-DDTHH:mm:ss",    // 2026-02-06T18:15:00
    "DD/MM/YYYY hh:mmA",      // 06/02/2026 06:15PM
    "DD/MM/YYYY hh:mm A",     // 06/02/2026 06:15 PM
  ];
  
  for (const fmt of formats) {
    const parsed = dayjs(value, fmt, true); // strict parsing
    if (parsed.isValid()) {
      return parsed;
    }
  }
  
  // Fallback to default parsing
  return directParse;
};

export const formatDate = (value, strategy = DATE_STRATEGY.DATE_AND_TIME) => {
  let format;

  switch (strategy) {
    case DATE_STRATEGY.DATE_AND_TIME:
      format = "DD/MM/YY h:mm A";
      break;
    case DATE_STRATEGY.DATE_ONLY:
      format = "DD/MM/YY";
      break;
    case DATE_STRATEGY.TIME_ONLY:
      format = "h:mm A";
      break;
    case DATE_STRATEGY.DATE_ISO:
      format = "YYYY-MM-DD";
      break;
    case DATE_STRATEGY.DATE_TIME_ISO:
      format = "YYYY-MM-DD HH:mm:ss";
      break;
    case DATE_STRATEGY.DATE_TIME_ISO_AMPM:
      format = "YYYY-MM-DD hh:mmA";
      break;
    case DATE_STRATEGY.DATE_US:
      format = "M/D/YYYY";  // No leading zeros to match database format
      break;
    default:
      format = "DD/MM/YY h:mm A";
  }

  return parseDate(value).format(format);
};

export const isValidTimeStamp = (timestamp) => {
  return dayjs(timestamp).isValid();
};
